"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crunch = void 0;
require("../JSON");
var JSON_1 = require("../JSON");
var utils_1 = require("../utils");
function flatten(data, set) {
  var recurse = function recurse(data) {
    return flatten(data, set);
  };
  var flattened = (0, JSON_1.isContainer)(data) ? (0, JSON_1.map)(data, recurse) : data;
  return set.add(flattened);
}
function crunch(data) {
  var set = (0, utils_1.CountedOrderedSet)();
  flatten(data, set);
  return set.values;
}
exports.crunch = crunch;